export default __webpack_public_path__ + "static/media/barbell.c7070589.svg";